import { PatientHealthcareAgreement } from "../../models/medical-record/patient-healthcare-agreement.model";

export class PatientHealthcareAgreementDetailsStruct {
    public patientHealthcareAgreement: PatientHealthcareAgreement = new PatientHealthcareAgreement();
    public nameHealthcareAgreement: string;
    public planName: string;
    public isSelectedInEpisode: boolean = false;
}